import type { Pagination } from 'src/types/common';
import type { AppLog, AppEvent, EventFilters, AppLogFilters } from 'src/types/event';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface EventsState {
  events: Pagination<AppEvent> | null;
  logs: Pagination<AppLog> | null;
  loading: Record<string, boolean>;
  filters: EventFilters;
  logsFilters: AppLogFilters;
}

const initialEventsState = {
  events: null,
  logs: null,
  loading: {},
  filters: {},
  logsFilters: {},
};

type Actions = {
  reset: () => void;
};

export const eventsModel = create(
  persist<EventsState & Actions>(
    (set) => ({
      ...initialEventsState,
      reset: () => {
        set(initialEventsState);
      },
    }),
    {
      name: 'sc-events-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
